import { useUser } from "@auth";
import { CelebrationsBirthdayPageTemplateProps } from "./template";
import { useNavigate } from "react-router-dom";

export const useCelebrationsBirthdayPage = (): CelebrationsBirthdayPageTemplateProps => {
    const navigate = useNavigate();
    const partner = useUser();
    

    const navigateToPage = (index: number, to: string) => {
        navigate(to);
      }
      const navigateBackTo = (to: string) => {
        navigate(to);
      }
    
      const onReturnPressed = () => {
        navigateBackTo("/dashboard/celebrations/main");
    }
    return {
        premiumUsers: partner?.premiumSettings?.[0]?.users.filter(item => item.userId !== "") || [],
        navigateToPage,
        onReturnPressed,
    }
}